import Icon from '@components/v2/ui/Icon/Icon';
import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import { Trash2 } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import { AddedOrderProductDropdownProps } from './AddedOrderProductDropdown.interfaces';
import { useStyles } from './AddedOrderProductDropdown.styles';

const AddedOrderProductDropdown = ({
  open,
  anchorEl,
  removeActionCustomLabel,
  handleClose,
  onClickRemove,
}: AddedOrderProductDropdownProps) => {
  const { classes } = useStyles();
  const { translate } = useTranslation();

  const handleClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    callback: () => void,
  ) => {
    event.stopPropagation();
    callback();
    handleClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        list: { disablePadding: true },
      }}
    >
      <MenuItem className={classes.menuItem} onClick={(event) => handleClick(event, onClickRemove)}>
        <Icon icon={Trash2} size="md" />
        <Typography>
          {translate(removeActionCustomLabel ?? LangEnum.CATALOGS_PRODUCTS_REMOVE_FROM_ORDER)}
        </Typography>
      </MenuItem>
    </Menu>
  );
};

export default AddedOrderProductDropdown;
